import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client  = sanityClient({
    projectId: 'p623o3s1',
    dataset:'production',
    apiVersion:'2022-02-01',
    useCdn:true,
    token: 'skfl4x8NAGHbDuZfqFspQYNvlAFRbaw4olrC9Jv2fGx5qJgcBjQHIfVQdvvXz9kvd2SOHQUqyjX8kLQ1thJ30TJGdg8u9hd7pcGNIIFe9o5YUIfEGno8okEhQBDgnJWAtwW6Vf9yR6cGp5lj8o76vz0QEpCj8gcaUWMhhuk1TFFSjUrMipOC',
}); 

const builder = imageUrlBuilder(client)

export const urlFor = (source) => builder.image(source)